import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { MenuOption } from '@app/core/models/menu-option.model';

@Component({
  selector: 'dhl-menu-item',
  templateUrl: './menu-item.component.html',
  styleUrls: ['./menu-item.component.scss']
})
export class MenuItemComponent {
  @Input() options: MenuOption[] = [];
  @Output() closeSidenav = new EventEmitter<void>();
  @ViewChild('subMenu', { static: true }) public subMenu: any;

  constructor(public router: Router) {}

}
